import api from './axiosConfig';

export const getNotifications = async (userId: string) => {
  try {
    const response = await api({
      method: 'get',
      url: `/v2/user/${userId}/notifications/active`,
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return [];
    }

    console.error(error);
    return [];
  }
};

export const readNotifications = async (userId: string, notificationId: string) => {
  try {
    const response = await api({
      method: 'patch',
      url: `/v2/user/${userId}/notification/${notificationId}/read`,
    });

    return {
      error: false,
      response: response.data.message,
    };
  } catch (error) {
    console.error(error);
  }
};

export const dismissNotifications = async (userId: string, notificationId: string) => {
  try {
    const response = await api({
      method: 'patch',
      url: `/v2/user/${userId}/notification/${notificationId}/dismiss`,
    });

    return {
      error: false,
      response: response.data.message,
    };
  } catch (error) {
    console.error(error);
  }
};
